import { createContext } from 'react'
import { EditorActions } from './backingTrackGeneratorEditorActions'
import { EditorState, initialEditorState } from './backingTrackGeneratorEditorState'


const BackingTrackEditorContext = createContext<[EditorState, React.Dispatch<EditorActions>]>([initialEditorState, () => {}])

export default BackingTrackEditorContext